const BuildURL = {
  Type: process.env.REACT_APP_ENV, //Production OR Staging OR Local OR Development OR Integration OR IntegrationDev
  Environment: {
    Production: {
      IPADDRESS: "tmilltrackshipment.azurewebsites.net",
    APPDEFAULTURL: "tmilltrackapi",
      ISSECURE: true,
      PORT: '',
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40115",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "https://lobsapintrfc.tmilltd.com/",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "1dde0da7-88b0-4062-a761-f2cd7118d2fc",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: 'https://freightprod.azurewebsites.net/freightforwarding'
      },
      MDM_URL: "https://mdmprod.azurewebsites.net/masterDataOperationsapi",
      PORT_URL: "https://portopprod.azurewebsites.net/portapi/v1/",
      FRONTLINE_URL: " https://frontlineprod.azurewebsites.net/frontlinefunctions/",
    },
    AZURE_QA: {
      IPADDRESS: "fflob.azurewebsites.net",
      APPDEFAULTURL: "tmilltrackapi",
      ISSECURE: true,
      PORT: '',
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40115",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "0e4e7359-9efb-4eaa-b092-a4e79db15c65",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: 'https://fflob.azurewebsites.net/freightforwarding/dashboard'
      },
      MDM_URL: "https://qamdm.azurewebsites.net/masterDataOperationsapi",
      PORT_URL: "https://portoperations.azurewebsites.net/portapi/v1/",
      FRONTLINE_URL: "https://frontlinefunctions.azurewebsites.net/frontlinefunctions/"
    },
    Local: {
      IPADDRESS: "localhost",
      APPDEFAULTURL: "tmilltrackapi",
      ISSECURE: false,
      PORT: 8080,
      EMAIL_SERVICE_END_POINT: "http://localhost:8095",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "0e4e7359-9efb-4eaa-b092-a4e79db15c65",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: 'http://localhost:3000/chail/dashboard'
      },
      MDM_URL: "https://qamdm.azurewebsites.net/masterDataOperationsapi",
      PORT_URL: "https://portoperations.azurewebsites.net/portapi/v1/",
      FRONTLINE_URL: "https://frontlinefunctions.azurewebsites.net/frontlinefunctions/"
    },
  },
  getServiceURL: function () {
    var SERVICEADDRESS;
    var port = BuildURL.Environment[BuildURL.Type].PORT;
    var IPADDRESS = BuildURL.Environment[BuildURL.Type].IPADDRESS;
    var isSecure = BuildURL.Environment[BuildURL.Type].ISSECURE;
    var httpText;

    if (isSecure) httpText = "https://";
    else httpText = "http://";

    if (port !== "") {
      //HOSTADDRESS =  'http://' + IPADDRESS + ':' + PORT + '/' + APPDEFAULTURL;
      SERVICEADDRESS =
        httpText +
        IPADDRESS +
        ":" +
        port +
        "/" +
        BuildURL.Environment[BuildURL.Type].APPDEFAULTURL;
    } else {
      //HOSTADDRESS = 'http://' + IPADDRESS + '/' + APPDEFAULTURL;
      SERVICEADDRESS =
        httpText +
        IPADDRESS +
        "/" +
        BuildURL.Environment[BuildURL.Type].APPDEFAULTURL;
    }
    return SERVICEADDRESS;
  },
  getEmailServiceEndpoint: function () {
    return BuildURL.Environment[BuildURL.Type].EMAIL_SERVICE_END_POINT;
  },
  getSapServiceEndpointConfig: function () {
    return BuildURL.Environment[BuildURL.Type].SAP_CONNECTION_DETAILS;
  },
  geAdAuthConfig: function () {
    return BuildURL.Environment[BuildURL.Type].AD_AUTHENTICATION;
  },
  getMasterServiceURL: function () {
    return BuildURL.Environment[BuildURL.Type].MDM_URL;
  },
  getPortServiceURL: function () {
    return BuildURL.Environment[BuildURL.Type].PORT_URL;
  },
  getFrontLineServiceURL: function () {
    return BuildURL.Environment[BuildURL.Type].FRONTLINE_URL;
  },
};
export default { BuildURL };
